import { createStore, applyMiddleware } from "redux";
import { reducers } from "./reducers/index";
import { createHashHistory } from "history";
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import { navigationMiddleware } from './navigateMiddleware';

// create history
export const history = createHashHistory();

// add the middlewares
let middlewares = [];

// create router middleware
const router = routerMiddleware(history);

middlewares.push(thunk);
middlewares.push(navigationMiddleware);
middlewares.push(router);

// apply the middleware
let middleware = applyMiddleware(...middlewares);

// get any data from localStorage
const getFromLocalStorage = () => {
  let initialStore = { Global: null };
  let initialValues = { userId: null, token: null };
  try {
    let userInfo = localStorage.getItem('userInfo');
    initialStore.Global = userInfo ? JSON.parse(userInfo) : initialValues;
  } catch (err) {
    initialStore.Global = initialValues;
  }
  return initialStore;
}

// create the store
export const store = createStore(reducers, getFromLocalStorage(), middleware);
